import { render, staticRenderFns } from "./FormBayarUtang.vue?vue&type=template&id=5b4ba293"
import script from "./FormBayarUtang.vue?vue&type=script&lang=js"
export * from "./FormBayarUtang.vue?vue&type=script&lang=js"
import style0 from "./FormBayarUtang.vue?vue&type=style&index=0&id=5b4ba293&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports